









import { Component, Vue, Prop } from 'vue-property-decorator'

@Component({})
export default class FileDropArea extends Vue {
  // ファイルドラッグ中
  private isDropOver = false

  @Prop({ default: null })
  fileType?: string

  /**
   * ファイルドラッグイベント
   * type == 'over'の場合、レイアウト制御
   */
  private onDrag(type: string) {
    this.isDropOver = type == 'over'
  }

  /**
   * ファイルドロップイベント
   */
  private onDropFile(event: DragEvent) {
    this.isDropOver = false

    const files = event.dataTransfer ? event.dataTransfer.files || [] : []
    if (files.length == 0) return alert('ファイルの読み込みに失敗しました。')
    if (files.length > 1) return alert('複数ファイルの読み込みはできません。')

    const file = files[0]

    this.$emit('drop', file)
  }
}
